import { DEFAULT_SEARCH_RESULT_IMAGE_URL } from '../constants';
import { ResourceSearchObject, ResourceSearchResult } from './types';

export const convertSearchObjectToSearchResult = ({
  id,
  relatedPageUid,
  url,
  title,
  description,
  image,
  label,
  categories,
  type,
  pageAdditionalData,
  updatedAt,
}: ResourceSearchObject): ResourceSearchResult => {
  const fallbackImage: ResourceSearchResult['image'] = {
    url: DEFAULT_SEARCH_RESULT_IMAGE_URL,
    data: null,
  };

  let parsedImage: ResourceSearchResult['image'] = fallbackImage;

  if (image && typeof image === 'string') {
    try {
      const parsedImageArray = JSON.parse(image);
      const firstImage = Array.isArray(parsedImageArray)
        ? parsedImageArray[0]
        : parsedImageArray;

      if (firstImage?.gatsbyImageData) {
        parsedImage = {
          url: firstImage.url || '',
          data: {
            gatsbyImageData: firstImage.gatsbyImageData,
          },
        };
      }
      // eslint-disable-next-line no-empty
    } catch {}
  }

  return {
    id,
    relatedPageUid,
    url,
    title,
    description,
    image: parsedImage,
    label,
    categories,
    type,
    pageAdditionalData,
    updatedAt,
  };
};
